import {INSTRUCTION_TYPE} from 'enums';

export const getRelatedInstructionMessage = (relatedEntity, messages, isChecklist) => {
  const length = relatedEntity.length;

  if (length === 0) {
    return isChecklist ? messages.relatedChecklists : messages.relatedInstructions;
  }

  if (length === 1) {
    const entity = relatedEntity[0];
    const isEntityChecklist = entity.type === INSTRUCTION_TYPE.CHECKLIST;

    return isEntityChecklist ? messages.relatedChecklists : messages.relatedInstructions;
  }

  if (length === 2) {
    const isEntity1Checklist = relatedEntity[0].type === INSTRUCTION_TYPE.CHECKLIST;
    const isEntity2Checklist = relatedEntity[1].type === INSTRUCTION_TYPE.CHECKLIST;

    if (isEntity1Checklist && isEntity2Checklist) {
      return messages.relatedChecklists;
    } else if (!isEntity1Checklist && !isEntity2Checklist) {
      return messages.relatedInstructions;
    } else {
      return messages.relatedInstructionAndChecklist;
    }
  }
};
